// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3gQ7D","name":"ConsentHeader_name__1RBbi","birthday":"ConsentHeader_birthday__1Wkqm","skeleton":"ConsentHeader_skeleton__2tIzO"};